import { render, staticRenderFns } from "./DeleteProductReviewBtn.vue?vue&type=template&id=04beb0ea&scoped=true&"
import script from "./DeleteProductReviewBtn.vue?vue&type=script&lang=js&"
export * from "./DeleteProductReviewBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04beb0ea",
  null
  
)

export default component.exports